import _ from 'lodash';
import { t } from '@lingui/macro';

export const START_LABEL = t`Start`;
export const END_LABEL = t`End`;
export const CUSTOM_LABEL = t`Custom`;

export const CUSTOM_ID = 'CUSTOM';
export const NOW_END_ID = 'NOW';

const MS_IN_A_MINUTE = 1000 * 60;
const MS_IN_A_YEAR = MS_IN_A_MINUTE * 60 * 24 * 365;

const DATE_EPOCH = 0;

export const MIN_DATE_TIME_VALUE = DATE_EPOCH; // cannot view data before this
export const MIN_DATE_TIME_RANGE = MS_IN_A_MINUTE; // cannot go lower than a minute
export const MAX_DATE_TIME_RANGE = MS_IN_A_YEAR; // 1 year

export const LAST_60_MIN = {
    id: 'LAST_60_MIN',
    name: t`Last 60 Minutes`,
    durationInMinutes: 60,
};

export const LAST_8_HRS = {
    id: 'LAST_8_HRS',
    name: t`Last 8 Hours`,
    durationInMinutes: 60 * 8,
};

export const LAST_24_HRS = {
    id: 'LAST_24_HRS',
    name: t`Last 24 Hours`,
    durationInMinutes: 60 * 24,
};

export const LAST_7_DAYS = {
    id: 'LAST_7_DAYS',
    name: t`Last 7 Days`,
    durationInMinutes: 60 * 24 * 7,
};

export const LAST_30_DAYS = {
    id: 'LAST_30_DAYS',
    name: t`Last 30 Days`,
    durationInMinutes: 60 * 24 * 30,
};

export const TIME_RANGE_PERIODS = [LAST_60_MIN, LAST_8_HRS, LAST_24_HRS, LAST_7_DAYS, LAST_30_DAYS];

export const IDS = [..._.map(TIME_RANGE_PERIODS, 'id'), CUSTOM_ID];

export const DEFAULT_OPTIONS = {
    autoRefresh: true,
    enableCustom: true,
    alignToGranularity: true,
    timeRanges: TIME_RANGE_PERIODS,
    minRangeMs: MIN_DATE_TIME_RANGE,
    maxRangeMs: MAX_DATE_TIME_RANGE,
};

export function getPeriod(id) {
    return _.find(TIME_RANGE_PERIODS, { id });
}
